import { Component } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { ReactComponent as Calendar } from 'assets/images/svg/calendar.svg';
export default class DateTimeRangeComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      error:false,
    };
  }

  dateChange = (dates) => {
    const [ startDate, endDate ] = dates;
    this.setState({ startDate, endDate },()=>{ 
      if((startDate && endDate) || (!startDate && !endDate)){
        const fromDate = startDate ? moment(startDate).set({ hour: 0, minute: 0, second: 0 }).format('YYYY-MM-DD HH:mm:ss') : '';
        const toDate = endDate ? moment(endDate).set({ hour: 23, minute: 59, second: 59 }).format('YYYY-MM-DD HH:mm:ss') : '';
        this.props.dispatchFunction({ fromDate,toDate })
      }
    });
  };

  resetDate = () => {
    this.setState({
      startDate:null,
      endDate:null
    })
  };

  focusChange = () => {
    const { startDate,endDate } = this.state 
    if(startDate && endDate) {
      return
    }
    this.setState({ error:true })
  }

  render() {
    const { startDate,endDate,error } = this.state   
    return (
      <>
        <div className="date-filter">
       <DatePicker
          selected={ startDate || null }
          onChange={ this.dateChange }
          startDate={ startDate }
          onCalendarClose={ this.focusChange }
          endDate={ endDate }
          maxDate={ endDate }
          dateFormat={ 'MMM dd, yyyy' }
          onFocus={ this.resetDate }
          selectsRange
          placeholderText={ 'Select Date Range' }
          isClearable={ true }
          onKeyDown={ (e) => {
            // Block all key inputs except Tab and Arrow keys
            const blockedKeys = [ 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight' ];
            if (!blockedKeys.includes(e.key) && !e.ctrlKey && !e.metaKey && e.key !== 'Tab') {
              e.preventDefault();
            }
            // If you want to block even Backspace:
            if (e.key === 'Backspace') {
              e.preventDefault();
            }
          } }
        />
       <div className="datepicker-placeholder">
          {/* <i className='datepicker-input-wrapper'><Calendar /></i> */}
       </div>
      </div>
      { ( (error && !startDate && endDate) || (error && startDate && !endDate)) && <span className='error'>Please select valid dates</span> }
      </>
    )
  }
}